<template>
  <div class="container tw-overflow-hidden">
    <div class="tw-flex tw-mt-4 lg:tw-mt-12 tw-flex-col-reverse lg:tw-flex-row tw-gap-6" :class="wrapperClasses">
      <!-- Form -->
      <div class="tw-w-full lg:tw-w-7/12" :class="formWrapperClasses">
        <lazy-library-title
          v-if="vars.titleText"
          tag="h3"
          :text="vars.titleText"
        />
        <lazy-library-form
          v-if="form"
          :form="form"
          :component="component"
          :is-form-name-visible="vars.isFormNameVisible || false"
        />
      </div>

      <!-- Görsel -->
      <div v-if="vars.guideImage" class="tw-w-full lg:tw-w-5/12">
        <div class="image-wrapper blog tw-h-full">
          <img
            alt=""
            loading="lazy"
            :src="String(vars.guideImage)"
            class="cover-image"
          />
        </div>
      </div>
    </div>
  </div>
</template>


<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';

export default defineNuxtComponent({
  name: 'GuideForm',

  mixins: [ComponentMixin],

  computed: {
    wrapperClasses() {
      return this.vars && this.vars.guideImage
        ? ['tw-justify-between']
        : ['tw-justify-center', 'tw-items-center'];
    },
    formWrapperClasses() {
      return this.vars && this.vars.guideImage ? [] : ['tw-mx-auto'];
    },
  },

  data() {
    return {
      form: null,
    };
  },
  created() {
    try {
      const form = getVariable(this.component, 'guide-form') as string;
      const parsedForm = JSON.parse(form);
      if (form && Object.keys(parsedForm).length) {
        this.form = parsedForm;
      }
    } catch (e) {}
  },
});
</script>

<script setup lang="ts"></script>

<style scoped>
@media screen and (max-width: 479px) {
  .image-wrapper.blog {
    width: unset;
  }
}
</style>
